<template lang="html">
  <footer id="footer" v-if="$route.name !== 'QRPage'">
    <section class="newsletter-section">
      <h2>Continuous discoveries await in your inbox</h2>
      <p>
        Subscribe to our mailing list to receive exclusive updates on our newest collections, invitations to private events, and tailored offers just for you.
      </p>

      <b-form @submit="onSubmit">
        <b-form-group>
          <b-form-input
            v-model="form.email"
            type="email"
            required
            placeholder="Your email"
          ></b-form-input>
        </b-form-group>

        <b-button type="submit" class="btn-send">Subscribe</b-button>
      </b-form>
    </section>

    <section class="footer-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 col-sm-4 col-lg col-footer">
            <h6>Offices</h6>

            <p>
              Lomas de Chapultepec,<br />
              Mexico City
            </p>
          </div>

          <div class="col-12 col-sm-4 col-lg col-footer">
            <h6>Contact us</h6>

            <p>
              <i class="fab fa-whatsapp mr-1"></i> +52 56 6257 6570
            </p>
            <p>
              <router-link to="/privacy-policy">Privacy Policy</router-link>
            </p>
            <!-- <p>
              <i class="fab fa-whatsapp mr-1"></i> 33 3333 3333
            </p> -->
          </div>

          <div class="col-lg col-logo">
            <router-link to="/">
              <img src="public/images/logo.png">
            </router-link>
          </div>

          <div class="col-0 col-sm-4 col-lg col-footer col-r">
            <h6>Website</h6>

            <p>
              <router-link to="/nosotros">Service Concierge</router-link>
            </p>
            <p>
              <router-link to="/nosotros">Straps and Accesories</router-link>
            </p>
          </div>

          <div class="col-12 col-sm-4 col-lg col-footer col-r">
            <div class="d-block">
              <a class="trans-250 link" target="_blank" href="https://www.instagram.com/legacy_timepieces_/" style="font-size: 40px;"><i class="fab fa-instagram"></i></a>
              <a class="trans-250 link" target="_blank" href="https://www.tiktok.com/@legacy.timepieces?_t=8iv3nUSTBCQ&_r=1" style="font-size: 38px;padding-left: 20px;"><i class="fab fa-tiktok"></i></a>
            </div>
            <!-- <h6>Help</h6> -->

            <!-- <p>
              <router-link to="/contacto">Contact</router-link>
            </p> -->

            <!-- <p>
              <router-link to="/terms-and-conditions">Terms and Conditions</router-link>
            </p> -->
            <!-- <p>
              <router-link to="">Preguntas Frecuentes</router-link>
            </p> -->
          </div>

          <!-- <div class="col-12 col-sm-6 col-lg col-footer col-r">
            <h6>Enlaces</h6>

            <p>
              <router-link to="/cart">Mi Carrito</router-link>
            </p>
            <p>
              <router-link to="/login">Mi Cuenta</router-link>
            </p>
            <p>
              <router-link to="/registrarse">Registrarse</router-link>
            </p>
          </div> -->

          <!-- <div class="col-12 col-networks">
            <div class="d-block">
              <!-- <a class="trans-250 link" href=""><i class="fab fa-facebook-square"></i></a> --**>
              <a class="trans-250 link" target="_blank" href="https://www.instagram.com/legacy_timepieces_/"><i class="fab fa-instagram"></i></a>
              <a class="trans-250 link" target="_blank" href="https://www.tiktok.com/@legacy.timepieces?_t=8iv3nUSTBCQ&_r=1"><i class="fab fa-tiktok"></i></a>
            </div>

            <!-- <span class="at">@jackbrotthers</span> -->
            <!-- <span class="hashtag">#<u class="pi">Decora</u><u class="bl">tu</u><u class="pu">Mundo</u></span> --**>
          </div> -->
        </div>
      </div>
    </section>

  </footer>
</template>

<script>
export default {
  data(){
    return{
      form: {
        email: null
      },

      redes: {
        telefono: '',
        email: '',
        facebook: '#',
        instagram: '#',
        youtube: '',
        address: 'Av. Diamante 2680.<br />Col. Bosques de la Victoria<br />Guadalajara, Jal.'
      }
    }
  },

  methods:{

    makeToast(variant = null, msg, title) {
        this.$bvToast.toast(msg, {
          title: title,
          variant: variant,
          solid: true,
          toaster: 'b-toaster-top-right',
          appendToast: true
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      var r = confirm("¿Deseas regístrate en newsletter? ");
      if (r == true) {
        axios.post(tools.url("/newsletter"), this.form).then((response)=>{
          this.makeToast('default', response.data.response, 'Correo registrado');
          this.form = {
            name: null,
            email: null,
            msg: null,
            check: null
          };
        }).catch( (error)=> {
          // console.log(error.response);
          let errors = error.response.data;
          // console.log(errors);
          this.makeToast('danger', error.response.data.name, 'Error');
          this.makeToast('danger', error.response.data.email, 'Error');
          this.makeToast('danger', error.response.data.phone, 'Error');
          this.makeToast('danger', error.response.data.msg, 'Error');
        });
      }
    },

    getRedes: function(){
      axios.get(tools.url('/redes')).then((response)=>{
        this.redes = response.data;;
      }).catch((error)=>{
        console.log(error);
      })
    }

  },

  beforeMount(){
    // this.getRedes();
  }
}
</script>
